import { GET_CUSTOMIZE_ORDER, GET_CUSTOMIZE_ORDER_SUCCESS, GET_CUSTOMIZE_ORDER_ERROR, UPDATE_CUSTOMIZE_ORDER, UPDATE_CUSTOMIZE_ORDER_SUCCESS, UPDATE_CUSTOMIZE_ORDER_ERROR } from "./actionTypes"

const orders = {
    campaigns: "campaigns",
    adgroup: "adgroup",
    profile: "profile",
    source: "source_setting",
    analytics: "analytics",
    leads_calls_source_setting: 'leads_calls_source_setting',
    conversion_logs: 'conversion_logs'
}

const INIT_STATE = {
    orders: {
        [orders.campaigns]: null,
        [orders.adgroup]: null,
        [orders.profile]: null,
        [orders.source]: null,
        [orders.analytics]: null
    },
    customize_order_loading: false,
    customize_order_error: null,
}

const CustomizeOrder = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_ORDER:
            return {
                ...state,
                customize_order_loading: true,
                customize_order_error: null,
            }
        case GET_CUSTOMIZE_ORDER_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                customize_order_loading: false,
            }
        case GET_CUSTOMIZE_ORDER_ERROR:
            return {
                ...state,
                customize_order_error: action.payload,
                customize_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_ORDER:
            return {
                ...state,
                customize_order_loading: false
            }
        case UPDATE_CUSTOMIZE_ORDER_SUCCESS:
            return {
                ...state,
                orders: {
                    ...state.orders,
                    [action?.component]: action?.payload
                },
                customize_order_loading: false
            }
        case UPDATE_CUSTOMIZE_ORDER_ERROR:
            return {
                ...state,
                customize_order_error: action.payload,
                customize_order_loading: false
            }

        default:
            return state
    }

}

export default CustomizeOrder;